import { Injectable, signal, computed, inject } from '@angular/core';

import { Ncm } from '../models/cadastro.model';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ModalStateService {

            // Canal para enviar dados de volta
            private modalResultSource = new Subject<any>();
            modalResult$ = this.modalResultSource.asObservable();

            // Canal para fechar o modal (trigger)
            private closeTriggerSource = new Subject<void>();
            closeTrigger$ = this.closeTriggerSource.asObservable();

            close(data?: any): void {
                this.modalResultSource.next(data);
                this.closeTriggerSource.next();
            }



}